import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import jQuery from 'jquery';

export default {
  searchController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$rootScope',
    '$state',
    'searchService',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $rootScope,
      $state,
      searchService
    ) {
      'use strict';

      function onTreeItemSelected(event, treeItem) {
        $scope.selectedFolder = treeItem;

        $scope.options = searchService.options;
        $scope.options.folderFilter = 0;

        $scope.options.query = '';
        $scope.hasSearchText = false;
      }

      function closeOptions() {
        $rootScope.displayOptions = false;
      }

      function toggleOptions() {
        $rootScope.displayOptions = !$rootScope.displayOptions;
        jQuery('#search-options').focus();
      }

      function showOptions() {
        $rootScope.displayOptions = true;
      }

      function queryTextChange() {
        $scope.hasSearchText = $scope.options.query.length > 0;
      }

      function searchKeyPress(event) {
        if (event.which === 13) {
          $scope.doSearch();
        }
      }

      function clearSearch() {
        $scope.options = searchService.options;
        $scope.options.query = '';

        $scope.hasSearchText = false;
        $scope.closeSearch();

        $rootScope.displayOptions = false;
      }

      function closeSearch() {
        $rootScope.$broadcast('closeSearch');
      }

      function verifyIsAllSelected() {
        var isAllSelected = true;

        for (var o in $scope.options) {
          if (
            typeof $scope.options[o] === 'boolean' &&
            $scope.options[o] === false
          ) {
            isAllSelected = false;
            break;
          }
        }

        $scope.unselectAllText = isAllSelected
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !isAllSelected;
      }

      function unselectAll() {
        $scope.options.code = $scope.isSelectAll;
        $scope.options.additionalFields = $scope.isSelectAll;
        $scope.options.title = $scope.isSelectAll;
        $scope.options.author = $scope.isSelectAll;
        $scope.options.documentType = $scope.isSelectAll;
        $scope.options.revisionDate = $scope.isSelectAll;
        $scope.options.description = $scope.isSelectAll;
        $scope.options.extension = $scope.isSelectAll;
        $scope.options.keywords = $scope.isSelectAll;
        $scope.options.folder = $scope.isSelectAll;

        $scope.unselectAllText = $scope.isSelectAll
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !$scope.isSelectAll;
      }

      function optionChanged() {
        if (
          $scope.options.query !== '' &&
          ($scope.getSearchFields().length > 0 ||
            $scope.options.searchOnContent)
        ) {
          $scope.doSearch();
        }
      }

      function doSearch() {
        if ($scope.options.query === '') {
          swal.fire(
            $filter('translate')('SEARCH EMPTY'),
            $filter('translate')('SEARCH EMPTY'),
            'warning'
          );
          return;
        }

        var searchFields = $scope.getSearchFields();

        if (
          searchFields.length === 0 &&
          ($scope.options.searchOnContent === null ||
            $scope.options.searchOnContent === false)
        ) {
          swal.fire(
            $filter('translate')('SELECT FIELDS'),
            $filter('translate')('SELECT FIELDS'),
            'warning'
          );
          $rootScope.displayOptions = true;
          return;
        }

        if ($scope.selectedFolder !== null && $scope.selectedFolder.Id < 0) {
          $scope.options.folderFilter = 0;
        }

        //searchService.searchParams.SearchTerm = $scope.options.query;
        searchService.searchParams.SearchFields = searchFields;
        searchService.searchParams.StartIndex = 0;
        searchService.searchParams.PageCount = 50;
        searchService.searchParams.AllFolders =
          parseInt($scope.options.folderFilter) === 0;
        searchService.searchParams.ThisFolder =
          parseInt($scope.options.folderFilter) === 1;
        searchService.searchParams.SubFolders =
          parseInt($scope.options.folderFilter) === 2;

        if ($scope.options.folderFilter !== 0) {
          searchService.searchParams.selectedFolder = $scope.selectedFolder;
        } else {
          searchService.searchParams.selectedFolder = undefined;
        }

        $rootScope.displayOptions = false;

        $state.go('home.search', {
          q: $scope.options.query,
          p: 1,
          f: searchFields.join([';']),
          l: $scope.options.folderFilter,
        });
        $scope.options.query = '';
        //$rootScope.$broadcast('doSearch');
      }

      function getSearchFields() {
        var searchFields = [];

        var fields = [
          'code',
          'additionalFields',
          'title',
          'author',
          'documentType',
          'revisionDate',
          'description',
          'extension',
          'keywords',
          'folder',
          'searchOnContent',
        ];

        for (var o in $scope.options) {
          if ($scope.options.hasOwnProperty(o)) {
            var i = fields.indexOf(o);
            if (i > -1) {
              var field = fields[i];

              if (field === 'keywords') {
                field = 'keyWords';
              } else if (field === 'searchOnContent') {
                field = 'content';
              }

              if ($scope.options[o] === true) {
                searchFields.push(field);
              }
            }
          }
        }

        return searchFields;
      }

      function run() {
        try {
          $rootScope.displayOptions = false;
          $scope.hasSearchText = false;
          $scope.isSelectAll = false;
          $scope.selectedFolder = null;
          $scope.options = searchService.options;
          $scope.unselectAllText = $filter('translate')('UNCHECK ALL');

          $rootScope.$on(
            'treeItemSelected',
            logWrapper(
              onTreeItemSelected,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.closeOptions = logWrapper(
            closeOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleOptions = logWrapper(
            toggleOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showOptions = logWrapper(
            showOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.queryTextChange = logWrapper(
            queryTextChange,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.searchKeyPress = logWrapper(
            searchKeyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearSearch = logWrapper(
            clearSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeSearch = logWrapper(
            closeSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.verifyIsAllSelected = logWrapper(
            verifyIsAllSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.unselectAll = logWrapper(
            unselectAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.optionChanged = logWrapper(
            optionChanged,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doSearch = logWrapper(
            doSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSearchFields = logWrapper(
            getSearchFields,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
